module.exports = __webpack_public_path__ + "a320c42ad3d22eecaf9df7415e11a7ff.pdf";